import Vue from 'vue';

const defaultState = {
    chartControleAnalyses: [],
};

const mutations = {
    setChartControleAnalyses(state, analyses) {
        Vue.set(state, 'chartControleAnalyses', analyses);
    },
    clearAnalyses(state) {
        Vue.set(state, 'chartControleAnalyses', []);
    },
};

const getters = {
    chartControleAnalyses: state => state.chartControleAnalyses,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    mutations,
};
